<template>
  <Overlay
    :isDarkMode="isDarkMode"
    :hideOnHover="false"
    :hideOnClick="true"
    :threshold="0.25"
    :reactivated="isReActivated"
    :class="['owc-hotspot-overlay', { 'owc-hotspot-overlay--dark': isDarkMode }]"
    v-on="$listeners"
  >
    <div class="owc-hotspot-overlay__wrapper">
      <slot></slot>
      <p class="owc-hotspot-overlay__title wb-type-copy-secondary">
        <span v-if="title" class="owc-hotspot-overlay__title--primary" v-html="title"></span>
        <span v-if="subtitle" class="owc-hotspot-overlay__title--secondary" v-html="subtitle"></span>
      </p>
    </div>
  </Overlay>
</template>

<script lang="ts">
import Vue from 'vue';
import Overlay from '@owc-packages/Overlay/src/Overlay.vue';
import {
  HotspotOverlayData,
  HotspotOverlayMethods,
  HotspotOverlayComputed,
  HotspotOverlayProps,
  HotspotOverlayComponent,
} from './HotspotOverlay';

export default (Vue as HotspotOverlayComponent).extend<
  HotspotOverlayData,
  HotspotOverlayMethods,
  HotspotOverlayComputed,
  HotspotOverlayProps
>({
  name: 'owc-hotspot-overlay',
  components: {
    Overlay,
  },
  props: {
    isDarkMode: {
      type: Boolean,
      required: true,
      default: true,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    isReActivated: {
      type: Boolean,
    },
  },
  beforeDestroy() {
    this.$emit('overlayClose');
  },
});
</script>

<style lang="scss">
@import '@owc-styles/utils';

.owc-hotspot-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: $z-index-content-lvl1;

  display: flex;
  align-items: center;
  justify-content: center;

  &--dark {
    color: var(--wb-white);
  }
  &__wrapper {
    text-align: center;
  }
  &__title {
    // not using --wb-spacing-xs because it changes over MQ-levels effectively becoming off-spec
    margin-top: calc(var(--wb-spacing-xxs) * 2); // 16px in all MQs

    &--secondary {
      display: block;

      @include breakpoint-from(mq4) {
        display: none;
      }
    }
  }
}
</style>
